(function () {
  function initRoot(root) {
    if (!root || root.dataset.productRedesignReady === '1') return;
    root.dataset.productRedesignReady = '1';

    initVariantMeta(root);
    initPaypalAlign(root);
  }

  /* Shopify writes data-pp-style-text-align empty; PayPal redraws when it is set */
  function initPaypalAlign(root) {
    var box = root.querySelector('.product-redesign__finance');
    if (!box || box.dataset.paypalAlignReady === '1') return;
    box.dataset.paypalAlignReady = '1';

    function align() {
      var msg = box.querySelector('#paypal-upstream-messaging-product');
      if (!msg || msg.getAttribute('data-pp-style-text-align') === 'center') return;
      msg.setAttribute('data-pp-style-text-align', 'center');
    }

    /* The app injects late and redraws on a variant change, so keep watching */
    align();
    new MutationObserver(align).observe(box, { childList: true, subtree: true });
  }

  /* SKU sits outside variant-selector — update on variant:change */
  function initVariantMeta(root) {
    var form = root.querySelector('form.product-redesign__form');
    if (!form || form.dataset.variantMetaReady === '1') return;
    form.dataset.variantMetaReady = '1';

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      var skuEl = root.querySelector('[data-product-redesign-sku]');
      if (!skuEl) return;

      var sku = variant && variant.sku ? variant.sku : '';
      skuEl.textContent = sku;
      var skuRow = skuEl.closest('.product-redesign__sku');
      if (skuRow) {
        if (sku) {
          skuRow.removeAttribute('hidden');
        } else {
          skuRow.setAttribute('hidden', '');
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-redesign]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initRoot(event.target.querySelector('[data-product-redesign]') || event.target);
  });
})();
